import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { responsiveStoreEnhancer } from 'redux-responsive'
import { routerMiddleware } from 'react-router-redux'
import createReducer from './reducers'
import apolloClient from './apollo'

const sagaMiddleware = createSagaMiddleware()

export default function configureStore (initialState, history) {
  const ownRouterMiddleware = routerMiddleware(history)

  const middlewares = [
    sagaMiddleware,
    ownRouterMiddleware,
    apolloClient.middleware()
  ]

  const enhancers = [
    responsiveStoreEnhancer,
    applyMiddleware(...middlewares)
  ]

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  /* eslint-disable no-underscore-dangle */
  /* istanbul ignore next */
  const composeEnhancers = (
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ) ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose
  /* eslint-enable */

  const store = createStore(
    createReducer(),
    initialState,
    composeEnhancers(...enhancers)
  )

  store.runSaga = sagaMiddleware.run
  store.asyncReducers = {}

  return store
}
